export const STAR_VERTEX_SHADER = `
  attribute float size;
  attribute float phase;
  attribute float twinkleSpeed;
  attribute float twinkleAmp;
  attribute vec3 color;
  uniform float time;
  uniform float pixelRatio;
  varying float vTwinkle;
  varying vec3 vColor;
  void main() {
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    float base = 1.0 - twinkleAmp;
    vTwinkle = base + twinkleAmp * (0.5 + 0.5 * sin(time * twinkleSpeed + phase));
    vColor = color;
    gl_PointSize = size * pixelRatio * (300.0 / -mvPosition.z);
    gl_Position = projectionMatrix * mvPosition;
  }
`;

export const STAR_FRAGMENT_SHADER = `
  uniform sampler2D map;
  varying float vTwinkle;
  varying vec3 vColor;
  void main() {
    vec4 tex = texture2D(map, gl_PointCoord);
    gl_FragColor = vec4(vColor, tex.a * vTwinkle);
  }
`;
